import { jsx as _jsx } from "react/jsx-runtime";
import Collapse from '@hellodarwin/core/lib/components/common/Collapse';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import { renderRichText } from '../../../../utils/richText';
import { FAQContentContainer } from '../styles';
import { useFaqRenderOptions } from './render-options';
import { FAQBlockContent } from './styles';
const FAQBlock = ({ items }) => {
    const theme = useTheme();
    const renderOptions = useFaqRenderOptions();
    return (_jsx(FAQContentContainer, { children: _jsx(Collapse, { gap: theme.spacing.md, styles: {
                panelContent: {
                    paddingInline: theme.spacing.md,
                    paddingBlock: theme.spacing.sm,
                },
                panelHeader: {
                    paddingInline: theme.spacing.md,
                    paddingBlock: theme.spacing.sm,
                },
            }, style: { position: 'relative' }, items: items.map(({ sys: { id }, fields: { title, bodyLong, body } }, index) => {
                return {
                    id: id || title || `question-${index}`,
                    title: title ? (_jsx(Typography.Title, { level: 3, elementTheme: "subtitle2", children: title })) : undefined,
                    children: (_jsx(FAQBlockContent, { children: !!bodyLong
                            ? renderRichText(bodyLong, renderOptions)
                            : !!body
                                ? body
                                : '' })),
                };
            }) }) }));
};
export default FAQBlock;
